export default __webpack_public_path__ + "static/media/passive-auth-sk-dark.193b0622.png";